"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Controls;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ControlsModule = _interopRequireDefault(require("./Controls.module.scss"));

var _Button = _interopRequireDefault(require("../../../../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../../../../inputElements/Button/EButtonType"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: i18n
function Controls(_ref) {
  var onBack = _ref.onBack,
      onNext = _ref.onNext,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_ControlsModule.default.controls, className)
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.SELECT,
    onClick: onBack
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _ControlsModule.default.buttonContent
  }, "Back")), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.SELECT,
    onClick: onNext
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _ControlsModule.default.buttonContent
  }, "Next")));
}